<template>
  <vx-card no-shadow>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">


        <vs-table :data="form.additional_information"  :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">
          <template slot="thead">
            <vs-th style="font-weight: normal" width="30%">Name</vs-th>
            <vs-th style="font-weight: normal" width="10%">Contained in product?</vs-th>
            <vs-th style="font-weight: normal" width="10%">Present on Manufacturing Site?</vs-th>
            <vs-th style="font-weight: normal" width="50%">Comment</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr style="cursor: pointer"   :key="indextr" v-for="(tr, indextr) in data">

              <vs-td :data="data[indextr].name">
                {{additional_information_display_names[indextr]}}
              </vs-td>
              <vs-td :data="data[indextr].is_product">
                <ValidationProvider :vid="indextr+'is_product'" :name="indextr+'is_product'" rules="" v-slot="{ errors }">
                  <vs-switch v-model="data[indextr].is_product" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                  </vs-switch>
                </ValidationProvider>
              </vs-td>
              <vs-td :data="data[indextr].is_manufacturing">
                <ValidationProvider :vid="indextr+'is_manufacturing'" :name="indextr+'is_manufacturing'" rules="" v-slot="{ errors }">
                  <vs-switch v-model="data[indextr].is_manufacturing" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                  </vs-switch>
                </ValidationProvider>
              </vs-td>
              <vs-td :data="data[indextr].is_manufacturing">
                <ValidationProvider :vid="indextr+'comment'" :name="indextr+'comment'" rules="" v-slot="{ errors }">
                  <vs-input type="text" v-model="data[indextr].comment" name="comment" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>


<!--        <div v-for="(additional, index) in form.additional_information" :key="index">-->
<!--          <div class="vx-row mb-3">-->
<!--            <div class="vx-col md:w-1/4 w-full md:mb-0">-->
<!--&lt;!&ndash;              <span class="text-bold " style="font-weight: bold">{{additional.name}}</span>&ndash;&gt;-->
<!--              <small class="label">Name</small> <br>-->
<!--              <span class="text-bold " style="font-weight: normal">{{ additional.name}}</span>-->
<!--            </div>-->
<!--            <div class="vx-col md:w-1/4 md:mb-0">-->
<!--              <ValidationProvider :vid="index+'is_product'" :name="index+'is_product'" rules="" v-slot="{ errors }">-->
<!--                <small class="label">Contained in product?</small>-->
<!--                <vs-switch v-model="additional.is_product" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">-->
<!--                  <span slot="on">Yes</span>-->
<!--                  <span slot="off">No</span>-->
<!--                </vs-switch>-->
<!--              </ValidationProvider>-->
<!--            </div>-->
<!--            <div class="vx-col md:w-1/4 md:mb-0">-->
<!--              <ValidationProvider :vid="index+'is_manufacturing'" :name="index+'is_manufacturing'" rules="" v-slot="{ errors }">-->
<!--                <small class="label">Present on Manufacturing Site?</small>-->
<!--                <vs-switch v-model="additional.is_manufacturing" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">-->
<!--                  <span slot="on">Yes</span>-->
<!--                  <span slot="off">No</span>-->
<!--                </vs-switch>-->
<!--              </ValidationProvider>-->
<!--            </div>-->
<!--            <div class="vx-col md:w-1/4 w-full md:mb-0">-->
<!--              <ValidationProvider :vid="index+'comment'" :name="index+'comment'" rules="" v-slot="{ errors }">-->
<!--                <small class="label">Comment</small>-->
<!--                <vs-input type="text" v-model="additional.comment" name="comment" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />-->
<!--              </ValidationProvider>-->
<!--            </div>-->
<!--          </div>-->

<!--          <vs-divider class="my-4" style="opacity: 0.2" color="" position="center"/>-->
<!--        </div>-->

        <div class="flex flex-wrap items-center justify-end">
          <vs-button button="submit" class="ml-auto mt-2">Save and Change</vs-button>
          <vs-button v-if="!isCompleted" @click.stop="onClickMarkAsComplete" class="ml-4 mt-2" type="border" color="warning">Mark As Complete</vs-button>
        </div>
      </form>
    </ValidationObserver>
  </vx-card>

</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from "vue-select";
  import RawMaterialForm from "@/mixins/RawMaterialForm";


  export default {
    name: "SupplierManufacturingHome",
    data() {
      return {
        form: {
          additional_information: [
            {
              name: "salt",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            },
            {
              name: "sugar",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            },
            {
              name: "alcohol",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            },
            {
              name: "antioxidant",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            },
            {
              name: "benzoate",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            },
            {
              name: "BHA",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            },
            {
              name: "BHT",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            },
            {
              name: "caffeine",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            },
            {
              name: "coal",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            },
            {
              name: "coconut",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            },
            {
              name: "colour",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            },
            {
              name: "dextrose",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            },
            {
              name: "emulsifier",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            },
            {
              name: "fruit",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            },
            {
              name: "gelatine",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            },
            {
              name: "glutamate",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            },
            {
              name: "glycerol",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            },
            {
              name: "herb",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            },
            {
              name: "HVP",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            },
            {
              name: "kiwi",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            },
            {
              name: "lactose",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            },
            {
              name: "legume",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            },
            {
              name: "meat",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            },
            {
              name: "paprika",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            },
            {
              name: "phenylalanine",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            },
            {
              name: "polyol",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            },
            {
              name: "potassium",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            },
            {
              name: "quinine",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            },
            {
              name: "seed",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            },
            {
              name: "smoke",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            },
            {
              name: "sorbic",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            },
            {
              name: "spice",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            },
            {
              name: "sweetener",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            },
            {
              name: "umbelliferae",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            },
            {
              name: "vanillin",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            },
            {
              name: "vegetable",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            },
            {
              name: "yeast",
              is_product: false,
              is_manufacturing: false,
              comment: ""
            }
          ]
        },
        id: null,
        status: {},
        additional_information_display_names : [
          'Added salt (%)', 'Added sugar (%)', 'Alcohol and derivatives (State %)', 'Antioxidants',
          'Benzoates', 'BHA E320', 'BHT E321', 'Caffeine', 'Coal Tar Dyes / Azo Dyes', 'Coconut and derivatives',
          'Colours (Please state Artificial or Natural)', 'Dextrose, Sucrose or Fructose', 'Emulsifiers or Gums',
          'Fruit and derivatives', 'Gelatine', 'Glutamate E620-E625', 'Glycerol', 'Herbs, Spices and derivatives',
          'HVP / TVP', 'Kiwi and derivatives', 'Lactose', 'Legumes', 'Meat and derivatives (including Beef, Pork and Poultry)',
          'Paprika and derivatives', 'Phenylalanine or Aspartame', 'Polyols (including Sorbitol)', 'Potassium Chloride',
          'Quinine (State Level) ', 'Seeds or derivatives thereof', 'Smoke', 'Sorbic acid (E200 - E203)',
          'Spices and derivatives', 'Sweeteners', 'Umbelliferae', 'Vanillin', 'Vegetables and derivatives', 'Yeast and derivatives'
        ]
      }
    },
    props : {
      isCompleted: { default: false },
    },
    mixins: [SuccessMessage, ErrorMessages, RawMaterialForm],
    components: {
      'v-select': vSelect,
    },
    methods: {
      onClickNext() {
        this.$emit('notify', 1)
      },
      async onClickMarkAsComplete() {
        this.$emit('mark-as-complete', 'is_raw_material_additional_information_marked_completed')
      },
      onClickSubmit() {
        this.status.is_raw_material_additional_information_complete ? this.$mixinsOpenUpdateConfirm() : this.onClickCreate()
      },
      async onClickUpdate() {
        this.$vs.loading()
        try {
          const data= (await SupplierRawMaterialRepository.UpdateRawMaterialAdditional(this.id, this.form))
          this.showSuccessMessage('Raw Material Additional Details Updated!')
          this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onClickCreate() {
        this.$vs.loading()
        try {
          const data= (await SupplierRawMaterialRepository.CreateRawMaterialAdditional(this.form))
          this.showSuccessMessage('Raw Material Additional Details Created!')
          this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },

      async loadData() {
        this.$vs.loading()
        const {data} = (await SupplierRawMaterialRepository.getRawMaterialAdditional(this.id)).data
        this.form.additional_information = data
        this.$vs.loading.close()
      },
      async loadStatus() {
        this.$vs.loading()
        const {data} = (await SupplierRawMaterialRepository.getRawMaterialStatus(this.id)).data
        this.status =data
        this.$vs.loading.close()
      }
    },
    async mounted() {
      this.id = this.$route.params.id
      this.form.supplier_raw_material_id =  this.id
      await this.loadStatus()
      if (this.status.is_raw_material_additional_information_complete ) {
        await this.loadData()
      }
    }

  }
</script>

<style scoped>

</style>
